import React, {useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {
  createIngredientMutation,
  getIngredientById,
  getIngredients,
  updateIngredientMutation
} from "./IngredientQueries";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import PageTitle from "../../../layout/PageTitle";
import {BackButton} from "../../../helpers/ButtonHelper";

const IngredientForm = () => {
  const params = useParams();
  const navigate = useNavigate()
  const [flash, setFlash] = useState({});
  const [ingredient, setIngredient] = useState({
    id: '',
    name: '',
    description: '',
    image: ''
  })
  const {loading, data} = useQuery(getIngredientById, {variables: {id: params.id}})

  let mutation = createIngredientMutation;
  let response_key = 'createIngredient'

  if (params.id) {
    mutation = updateIngredientMutation
    response_key = 'updateIngredient'

    if (!ingredient.id && !loading && data)
      setIngredient(data.ingredient)
  }

  const [saveCall] = useMutation(mutation, {refetchQueries: [getIngredients]})

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: response_key,
      flash_callback: setFlash,
      success: () => {
        if (!params.id)
          navigate(`/ingredients  `)
      }
    })
  }

  return (
    <Container>
      <PageTitle title={params.id ? 'Modifica ingredientul' : 'Adauga ingredient'}/>
      <Row className='d-sm-flex my-2 align-items-start'>
        <Col>
          <form onSubmit={onSubmit}>
            <input type='hidden' name='id' id="id" defaultValue={ingredient.id}/>

            <Row className="mb-2">
              <Col>
                <label htmlFor="name">Denumire</label>
                <input type='text' name='name' className="form-control" id="name" defaultValue={ingredient.name}/>
              </Col>
            </Row>
            <Row className='mb-2'>
              <Col>
                <label htmlFor="details">Descriere</label>
                <textarea name='details' className="form-control" id="details" defaultValue={ingredient.details}/>
              </Col>
            </Row>

            <Row className="mb-3">
              <FlashMessage flash={flash} buttons={
                <>
                  <BackButton to='/ingredients' className='float-end' showText={true} size='md'/>
                  <Button type='submit' className='float-end'>Salveaza</Button>
                </>
              }/>
            </Row>
          </form>
        </Col>
      </Row>
    </Container>
  )
};

export default IngredientForm;